(() => {
  const returnUrl = new URL(window.location.href);
  const formId = returnUrl.searchParams.get('cb_tds');
  if (!formId || returnUrl.searchParams.get('contact_posted') !== 'true') return;

  // This link is rendered only in the native contact form's success state.
  const link = Array.from(document.querySelectorAll('[data-cb-tds-download]'))
    .find((element) => element.dataset.cbTdsDownload === formId);
  if (!link) return;

  // Clear the one-time handoff before navigating, so Back doesn't reopen the PDF.
  returnUrl.searchParams.delete('contact_posted');
  returnUrl.searchParams.delete('cb_tds');
  try {
    window.history.replaceState(window.history.state, '', returnUrl.href);
  } catch (_) {
    // The visible link still works if this browser restricts history updates.
    return;
  }

  // Same-tab navigation avoids popup blocking after a form submission/redirect.
  window.location.assign(link.href);
})();
